import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4cfcb5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ProductMultiSelect = _resolveComponent("ProductMultiSelect")!
  const _component_CategoryMultiSelect = _resolveComponent("CategoryMultiSelect")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RapportFilter = _resolveComponent("RapportFilter")!

  return (_openBlock(), _createBlock(_component_RapportFilter, {
    startAt: _ctx.input.startAt,
    "onUpdate:startAt": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.startAt) = $event)),
    endAt: _ctx.input.endAt,
    "onUpdate:endAt": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.input.endAt) = $event)),
    period: _ctx.input.period,
    "onUpdate:period": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.input.period) = $event)),
    loading: _ctx.loading,
    onValidate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.initData())),
    label: _ctx.$t('rapport.movementCount'),
    total: _ctx.movements.length,
    symbol: ""
  }, {
    table: _withCtx(() => [
      _createVNode(_component_DataTable, {
        dataKey: "id",
        rowHover: false,
        value: (_ctx.movements as any[]),
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        rows: 20,
        "rows-per-page-options": _ctx.rowsPerPageOptions,
        filterDisplay: "menu",
        showGridlines: "",
        paginator: false,
        responsiveLayout: "scroll",
        globalFilterFields: ['product', 'category'],
        class: "p-datatable-sm",
        "sort-field": "createdAt",
        "sort-order": -1,
        scrollable: "",
        "scroll-height": "flex"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-sm p-button-outlined p-button-rounded",
            icon: "pi pi-refresh",
            label: _ctx.$t('clear'),
            onClick: _ctx.refresh
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            disabled: !_ctx.movements.length,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.print())),
            label: _ctx.$t('pos.print'),
            icon: "pi pi-print"
          }, null, 8, ["disabled", "label"]),
          _createElementVNode("span", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters.global.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.global.value) = $event)),
              placeholder: _ctx.$t('search'),
              style: {"width":"100%"}
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            "show-add-button": false,
            showFilterOperator: false,
            field: "createdAt",
            header: _ctx.$t('date'),
            dataType: "date",
            sortable: true,
            "sort-field": "createdAt"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_Calendar, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                dateFormat: _ctx.$t('format.range'),
                placeholder: _ctx.$t('format.range'),
                style: {"min-width":"200px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "product",
            "show-filter-match-modes": false,
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "productId",
            "sort-field": "product",
            header: _ctx.$t('product.product'),
            style: {"min-width":"220px"}
          }, {
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_ProductMultiSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                items: _ctx.resume.products,
                style: {"max-width":"220px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-database",
                class: "p-button-sm p-ml-2",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            showFilterMatchModes: false,
            "show-add-button": false,
            showFilterOperator: false,
            field: "category",
            sortable: true,
            "filter-field": "categoryId",
            "sort-field": "category",
            header: _ctx.$t('product.category'),
            style: {"min-width":"220px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.category), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_CategoryMultiSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                items: _ctx.resume.categories,
                style: {"max-width":"220px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-database",
                class: "p-button-sm p-ml-2",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            "sort-field": "movement",
            sortable: true,
            field: "movement",
            header: _ctx.$t('stock.movement'),
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "movement",
            dataType: "numeric"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.getSign(data.movement, data.motif)) + " ", 1),
              _createVNode(_component_NumberFormatter, {
                value: data.movement
              }, null, 8, ["value"])
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            "sort-field": "balance",
            sortable: true,
            field: "balance",
            header: _ctx.$t('rapport.balance'),
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "balance",
            dataType: "numeric"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.balance
              }, null, 8, ["value"])
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "filters", "rows-per-page-options"])
    ]),
    _: 1
  }, 8, ["startAt", "endAt", "period", "loading", "label", "total"]))
}